module.exports = __webpack_public_path__ + "img/zhonghcc.99c297bd.jpg";